export default "__VITE_ASSET__d05248b9__"